const apiServiceConfig = {
    getHomePageData:'/website/homepage/getHomePageData',//首页
    getPageByMenuId:'/website/homepage/getPageByMenuId',//公司概况
    getArticleList:'/website/homepage/getArticleList',//列表数据
    getArticleById:'/website/homepage/getArticleById',//详情
    getPartyBuildData:'/website/homepage/getPartyBuildData',//党建园地
    getWaterCultureData:'/website/homepage/getWaterCultureData',//水文化
    getChildrenMenu:'/website/homepage/getChildrenMenu',//直属子公司
    submitFeedback:'/website/homepage/submitFeedback',//意见反馈
    submitCustomerDemand:'/website/homepage/submitCustomerDemand',//业务诉求
}
export default apiServiceConfig